import _ from "lodash";
import { SingleSelect } from "../base/singleSelect";
import { LocalCustomSelect } from "./customSelect";
export class LocalSingleSelect extends SingleSelect {
    constructor(nativeSelect, renderInline) {
        const localCustomSelect = new LocalCustomSelect(nativeSelect);
        const textInput = nativeSelect.data("custom-select-text-input");
        const options = localCustomSelect.getOptions();
        super(Object.assign(Object.assign({}, options), { items: textInput
                ? options.items.filter((i) => i.value !== undefined)
                : options.items, renderInline, itemsVisibleOnShow: !textInput }));
        this.nativeSelect = nativeSelect;
        this.localCustomSelect = localCustomSelect;
        this.textInput = textInput;
    }
    shouldShowOnClick(e) {
        return !this.textInput && super.shouldShowOnClick(e);
    }
    selectBySearchKeys() {
        if (this.textInput)
            return;
        super.selectBySearchKeys();
    }
    async updateDisplayedItems(searchText) {
        super.updateDisplayedItems(searchText);
        if (!this.textInput)
            return;
        searchText === "" || !_.some(this.getListItems().not(".hidden"))
            ? this.hideList()
            : this.showList();
        this.autoSelect(searchText);
    }
    insert(customSelect) {
        this.nativeSelect.after(customSelect);
    }
    setSelected(chosenItem) {
        super.setSelected(chosenItem);
        const value = chosenItem.value === undefined ? "" : chosenItem.value;
        const chosenOption = this.nativeSelect
            .find("option")
            .filter((_, o) => $(o).val() === value);
        this.nativeSelect.find("option").removeProp("selected");
        chosenOption.prop("selected", true);
        this.nativeSelect.trigger("change");
    }
    addItems(...items) {
        super.addItems(...items);
        this.localCustomSelect.addItems(...items);
    }
    removeItems(...items) {
        super.removeItems(...items);
        this.localCustomSelect.removeItems(...items);
    }
    enable() {
        super.enable();
        this.localCustomSelect.enable();
    }
    disable() {
        super.disable();
        this.localCustomSelect.disable();
    }
}
